import { render, staticRenderFns } from "./DashboardStatisticsCard.vue?vue&type=template&id=6709624c"
import script from "./DashboardStatisticsCard.vue?vue&type=script&lang=js"
export * from "./DashboardStatisticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports